import { useTranslation } from '@hotjar/translations';
import { Text, Radio, Tooltip, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const STATUS_TITLE_ID = 'survey-status-title';

const SurveyStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${tokens.spacer.x1};
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${tokens.spacer.x2};
`;

export type SurveyStatusProps = {
  isActive: boolean;
  onStatusChange: (value: boolean) => void;
};

export const SurveyStatus = ({ isActive, onStatusChange }: SurveyStatusProps): JSX.Element => {
  const { t } = useTranslation('feedback', { keyPrefix: 'survey-status' });
  return (
    <SurveyStatusContainer>
      <Tooltip text={t('tooltip')}>
        <Text textType="subtitle2" id={STATUS_TITLE_ID}>
          {t('title')}
        </Text>
      </Tooltip>
      <RadioGroup role="radiogroup" aria-labelledby={STATUS_TITLE_ID}>
        <Radio
          name="survey-status"
          isChecked={isActive === false}
          labelContent={t('inactive')}
          value="false"
          onChange={() => onStatusChange(false)}
        />
        <Radio
          name="survey-status"
          isChecked={isActive === true}
          labelContent={t('active')}
          value="true"
          onChange={() => onStatusChange(true)}
        />
      </RadioGroup>
    </SurveyStatusContainer>
  );
};
